
import React, { useEffect, useState } from "react";
import { AppBar, Tab, Tabs, Container, Paper, Grid } from "@mui/material";
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import GeneralTab from "../components/general/clientOther";
import GeneralQuote from "../components/general/generalQuote";
import DriverInformationList from "../components/drivers/driverInformationList";
import VehicleInformationList from "../components/cars/VehicleInformationList";
// import Coverage from "../components/Coverage/coverage";
// import Comparision from "../components/compareQuotes/comparision";
import CompareQuotesTab from "../components/compareQuotes/comparision";
import { useLocation } from "react-router-dom";
const theme = createTheme({
  palette: {
    text: {
      primary: "#242929",
      secondary: "#077BFD",
    },
  },
});

const StyledTabs = styled(Tabs)(({ theme }) => ({
  "& .MuiTab-root": {
    minWidth: "unset",
    fontWeight: 600,
    padding: '25px 0',
    fontSize: "1rem",
    textTransform: "none",
    letterSpacing: "0.5px",
    fontFamily: '"Poppins", sans-serif',
    color: theme.palette.text.primary,
    borderBottom: "3px solid transparent",
    transition: "border-bottom-color 0.3s",
    "&:hover": {
      borderBottomColor: theme.palette.text.secondary,
    },
  },
  "& .Mui-selected": {
    color: theme.palette.text.secondary,
    borderBottom: "3px solid #077BFD"
  },
  "& .MuiTabs-indicator": {
    display: "none", // Hide the default indicator
  },
  "& .Mui-visited": {
    color: theme.palette.text.secondary,
  },
}));

function GailView({setView}) {
  const [value, setValue] = useState(3);
  const [pageIndex, setPageIndex] = useState(0);
  const [formData, setFormData] = useState({});
  const [vehicleData]=useState({});
  const [refresh, setRefresh] = useState(false);
  const flag=true;

  const location = useLocation();
  const { generalData } = location.state || {};
  const id = generalData?.gpId;

  const [visitedTabs,setVisitedTabs] = useState(new Array(6).fill(false)); // Initialize an array of 6 boolean values to keep track of visited tabs

  const refreshComparisonTab = () => {
    // console.log("Refreshing Comparison Tab Data...");
    setRefresh(true); // Trigger re-render if needed
  };

  useEffect(() => {
    if (value === 3) {
      const timeout = setTimeout(() => {
        refreshComparisonTab();
      }, 1000);

      return () => clearTimeout(timeout); // Cleanup timeout
    }
  }, [value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPageIndex(0); // Reset pageIndex when switching tabs
    setVisitedTabs((prevVisitedTabs) => {
      const newVisitedTabs = [...prevVisitedTabs];
      newVisitedTabs[newValue] = true; // Set the new tab as visited
      return newVisitedTabs;
    });
  };

  const handleNext = () => {
    const totalPages = formPages[value].length;
    if (pageIndex < totalPages - 1) {
      setPageIndex(pageIndex + 1); // Move to the next page of the form
    } else {
      if (value < formPages.length - 1) {
        setValue(value + 1); // Move to the next tab
        setPageIndex(0); // Reset pageIndex when switching tabs
        setVisitedTabs((prevVisitedTabs) => {
          const newVisitedTabs = [...prevVisitedTabs];
          newVisitedTabs[value + 1] = true; // Set the new tab as visited
          return newVisitedTabs;
        });
      }
    }
  };

  const handleBack = () => {
    if (pageIndex > 0) {
      setPageIndex(pageIndex - 1); // Move to the previous page of the form
    } else {
      if (value > 0) {
        setValue(value - 1); // Move to the previous tab
        const prevTabPages = formPages[value - 1].length;
        setPageIndex(prevTabPages - 1); // Set pageIndex to the last page of the previous tab
        setVisitedTabs((prevVisitedTabs) => {
          const newVisitedTabs = [...prevVisitedTabs];
          newVisitedTabs[value - 1] = true; // Set the previous tab as visited
          return newVisitedTabs;
        });
      }
    }
  };

  const handleSubmitGeneralTab = (data) => {
    setFormData(data);
    handleNext();
  };


const formPages=[
  [
    <GeneralTab  handleNext={handleNext} handleSubmitGeneralTab={handleSubmitGeneralTab} id={id} />,
    <GeneralQuote handleNext={handleNext} handleBack={handleBack} data={formData}  id={id}/>
  ],
  [

    <DriverInformationList handleNext={handleNext} handleBack={handleBack} id={id}/>
  ],
  [

    <VehicleInformationList handleNext={handleNext} handleBack={handleBack} vehicleData={vehicleData} id={id}/>
  ],

  [
     <CompareQuotesTab handleNext={handleNext} handleBack={handleBack} id={id} flag={flag}/>
  ],
]


  return (
    <ThemeProvider theme={theme}>
        <AppBar position="static" color="default">
          <Container>
            <StyledTabs value={value} onChange={handleChange} variant="fullWidth">
              <Tab id="General" label="General" />
              <Tab id="Drivers" label="Drivers" />
              <Tab id="Cars" label="Cars" />
              {/* <Tab label="Coverage" /> */}
              <Tab id="Comparison" label="Comparison" />
              {/* <Tab label="Breakdown" /> */}
            </StyledTabs>
          </Container>
        </AppBar>

        <Paper sx={{ p: 2, margin: '0 auto', boxShadow: 'none'}}>
          <Grid item xs={12} sx={{ margin: '0 auto'}}>
            {formPages[value][pageIndex]}
          </Grid>
        </Paper>
    </ThemeProvider>
  );
}

export default GailView;
